import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.TagsBySentimentTable extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'tags_by_sentiment'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  icon: 'table'

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    @columns = ['Temática', 'Positive', 'Negative', 'Neutral']
    @tableData = { columns: @columns, data: [], types: ['string', 'string', 'string', 'string'], options: { columns: { color: [{ name: 'Positive', color: @colors['positive'] }, { name: 'Neutral', color: 'lightgrey' }, { name: 'Negative', color: @colors['negative'] }] } } }
    @$el.html(@template(self: this))
    @requestsCompleted = 0
    @bindChartsReady(@columns.length - 1)
    @addChart()
    return this

  addChart: ->
    @$el.find('.chart_container').addClass('processing')
    $.post(@options.chartApi.crossDimension, @extendedQuery({ first_dimension: 'sentiment', second_dimension: 'labels' }), (response) =>
      @chartReady('.chart_container')
      results = []
      for serie in response.series
        total = _.reduce(serie.data, ((acum, data) -> acum + data.y), 0)
        secondDimensionValues = []
        secondDimensionValues.push(@_findValueForColumn(index, serie, total)) for index in [1, 2, 3]
        results.push [serie.name].concat(secondDimensionValues)
      @tableData.data = results
      @_drawTable()
    )

  _findValueForColumn: (index, serie, total) ->
    value = _.find(serie.data, (data) => data.name.toLowerCase() == @columns[index].toLowerCase()).y || 0
    (if total == 0 then 0 else ((value / total) * 100).toFixed(2)) + '%'

  _drawTable: ->
    @$el.find('.chart_container').html(new Monitoring.Reports.Executive.TableView(response: @tableData).render().el)
